import React from 'react'
import './intro-card-style.css'

const IntroCard = ({ children }) => (
  <div className="intro-card">
    {children}
  </div>
)

export default IntroCard